var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{class:_vm.cssClass,attrs:{"to":_vm.to}},[(_vm.icon)?_c('v-icon',{attrs:{"dark":!!_vm.dark || _vm.dark === '',"left":""}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_c('strong',[_vm._v(_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }